import { get } from 'lodash';

type CompanyProp = CurrentCompany | Company | null | undefined;

export const jobSubmissionListsEnabled = (company: CompanyProp) =>
  !!get(company, 'subscription_plan.features.job_submission_lists', false);

export const marketingListsEnabled = (company: CompanyProp) =>
  !!get(company, 'subscription_plan.features.marketing_lists', false);

export const pdfExportEnabled = (company: CompanyProp) =>
  !!get(company, 'subscription_plan.features.pdf_export', false);

export const candidateSearchEnabled = (company: CompanyProp) =>
  !!get(company, 'subscription_plan.features.candidate_search', false);

export const listsEnabled = (company: CompanyProp) =>
  jobSubmissionListsEnabled(company) || marketingListsEnabled(company);

export const pdfExportOnly = (company: CompanyProp) =>
  !marketingListsEnabled(company) &&
  !jobSubmissionListsEnabled(company) &&
  pdfExportEnabled(company);

export const candidateSearchOnly = (company: CompanyProp) =>
  !marketingListsEnabled(company) &&
  !jobSubmissionListsEnabled(company) &&
  !pdfExportEnabled(company) &&
  candidateSearchEnabled(company);

export const noFeatureEnabled = (company: CompanyProp) =>
  !jobSubmissionListsEnabled(company) &&
  !marketingListsEnabled(company) &&
  !pdfExportEnabled(company) &&
  !candidateSearchEnabled(company);
